import { loadImageTexture } from '@/util/loader';
import * as THREE from 'three';

class FaceSceneManager {
  private static instance = new FaceSceneManager();
  private scene;
  private height!: number;
  private width!: number;
  private renderer!: THREE.Renderer;
  private camera!: THREE.Camera;
  elements = undefined;

  constructor() {
    this.scene = new THREE.Scene();
  }
  static getInstance(): FaceSceneManager {
    return FaceSceneManager.instance;
  }
  init(height: number, width: number) {
    this.height = height;
    this.width = width;
    this.initCamera();
    this.initLight();
    this.createRenderer();
    // this.animate();
    // this.rendering();
  }
  initCamera() {
    const camera = new THREE.OrthographicCamera(
      this.width / -2,
      this.width / 2,
      this.height / 2,
      this.height / -2,
      -0.1,
      10000
    );

    camera.position.set(0, 0, 2);
    this.camera = camera;

    this.scene.add(camera);
  }
  initLight() {
    const light = new THREE.AmbientLight(0xffffff, 1.0);
    this.scene.add(light);
  }
  createRenderer() {
    const renderer_ = new THREE.WebGLRenderer({
      // preserveDrawingBuffer: true,
      antialias: true,
    });
    renderer_.setSize(this.width, this.height);
    renderer_.setClearColor(0x000000, 0);
    renderer_.autoClear = false;
    const faceCanvas = document.getElementById('face_canvas');
    if (faceCanvas) faceCanvas.appendChild(renderer_.domElement);
    this.renderer = renderer_;
  }

  async renderElements() {
    const texture = await loadImageTexture(
      'https://images.unsplash.com/photo-1609940434020-3bc452a4bfd4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NDMzMzd8MHwxfHNlYXJjaHwxfHxCZXN0JTIwcGhvdG98ZW58MHx8fHwxNzYwNTQxMzQyfDA&ixlib=rb-4.1.0&q=80&w=400'
    );
    // Create material and sprite
    const material = new THREE.SpriteMaterial({ map: texture });
    const sprite = new THREE.Sprite(material);
    sprite.scale.set(200, 400, 1);
    sprite.position.set(5, 10, 1);
    this.scene.add(sprite);
    this.rendering();
  }

  animate() {
    requestAnimationFrame(() => this.animate());

    // Render the scene
    this.renderer.render(this.scene, this.camera);
  }
  //   rendering() {
  //     if (!this.renderer) return;
  //     this.renderer.render(this.scene, this.camera);
  //     requestAnimationFrame(this.rendering.bind(this));
  //   }
  getScene() {
    return this.scene;
  }
  // async snapshot(videoId: string) {
  //   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  //   // const result = await captureThreeScene(
  //   //   this.scene,
  //   //   this.camera,
  //   //   this.height,
  //   //   this.width,
  //   //   videoId
  //   // );
  //   // const tempCanvas = document.createElement('canvas');
  //   // tempCanvas.width = 877;
  //   // tempCanvas.height = 1004;
  //   // const tempRenderer = new THREE.WebGLRenderer({
  //   //   canvas: tempCanvas,
  //   //   preserveDrawingBuffer: true,
  //   //   antialias: true,
  //   //   alpha: true,
  //   // });
  //   // tempRenderer.setSize(877, 1004);
  //   // // tempRenderer.setPixelRatio(window.devicePixelRatio);
  //   // // Copy settings from main renderer if needed
  //   // tempRenderer.render(this.scene, this.camera);
  //   // tempRenderer.domElement.toBlob(blob => {
  //   //   const link = document.createElement('a');
  //   //   link.href = URL.createObjectURL(blob);
  //   //   link.download = `screenshot-${Date.now()}.png`;
  //   //   link.click();
  //   //   URL.revokeObjectURL(link.href);
  //   // }, 'image/png');
  //   // tempRenderer.dispose();
  //   // tempRenderer.forceContextLoss();
  //   // tempCanvas.remove();
  // }
  rendering() {
    this.renderer.render(this.scene, this.camera);
  }
}

export { FaceSceneManager };
